module.exports = __webpack_public_path__ + "static/media/cover.9e089d89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/scrl/cover.png
// module id = 47
// module chunks = 0